// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] || chunkId) + "." + {"265":"bf8b87b7","297":"1a7b5698","484":"1694b562","643":"d675296a"}[chunkId] + ".chunk.js";
};